import React from 'react';

import { FormattedMessage } from '../../../util/reactIntl';
import { Avatar, NamedLink } from '../../../components';

import css from './ClassDetail.module.css';

const IconMail = () => (
  <svg className={css.contactIcon} viewBox="0 0 24 24" role="none">
    <rect x="3" y="5" width="18" height="14" rx="2" fill="none" strokeWidth="2" />
    <path d="m4 7 8 6 8-6" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/**
 * The provider card (right column): avatar, business name, bio from provider onboarding
 * (publicData.businessName/businessDescription with profile fallbacks), and Contact provider ->
 * the existing inquiry modal (real default-inquiry plumbing). The mockup's "Verified provider"
 * badge, social icons and years-of-experience tagline are intentionally absent: no data models
 * exist for them (flagged to the client).
 */
const ClassProviderCard = props => {
  const { listing, currentUser, authorDisplayName, onContactUser } = props;
  const author = listing.author;

  if (!author?.id) {
    return null;
  }

  const profile = author.attributes?.profile || {};
  const providerPublicData = profile.publicData || {};
  const displayName = providerPublicData.businessName || authorDisplayName;
  const bio = providerPublicData.businessDescription || profile.bio || null;

  const isOwnListing = currentUser?.id && author.id?.uuid === currentUser.id?.uuid;

  return (
    <section id="provider" className={css.card}>
      <div className={css.providerHeader}>
        {/* Logo when uploaded; otherwise the shared Avatar falls back to the BUSINESS name's
            first letter (userAbbreviatedName), never the owner's personal initials. */}
        <Avatar className={css.providerAvatar} user={author} disableProfileLink={false} />
        <div className={css.providerNameGroup}>
          {/* The name links to the provider's public business profile, like the avatar. */}
          <h2 className={css.providerName}>
            <NamedLink
              className={css.providerNameLink}
              name="ProfilePage"
              params={{ id: author.id.uuid }}
            >
              {displayName}
            </NamedLink>
          </h2>
        </div>
      </div>
      {bio ? <p className={css.providerBio}>{bio}</p> : null}
      {!isOwnListing ? (
        <button type="button" className={css.contactProvider} onClick={onContactUser}>
          <IconMail />
          <FormattedMessage id="ClassDetailPage.contactProvider" />
        </button>
      ) : null}
    </section>
  );
};

export default ClassProviderCard;
